import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Tr} from "@/i18n/i18n";
import {SquareButton} from "@/scenes.ui/square-button";
import {Keys} from "@/constants/key";
import {PaymentChangeService} from "@/services/payment-change-service";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import {PaymentChangePanel} from "@/scenes.ui/payment-change-panel";
import PlayerStore from "@/store/player";
import {Markers} from "@/constants/marker";

export class EarnGemsPanel extends Phaser.GameObjects.Container {

    public static HEIGHT = 174;

    private paymentChangeService: PaymentChangeService = new PaymentChangeService();

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, detailsCallback: () => unknown) {
        super(scene);

        this.scene = scene;
        this.height = EarnGemsPanel.HEIGHT;

        const back = SpriteUtils.addImage(this.scene, -300, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, this.height + 60);
        this.add(back);

        const titleLight = SpriteUtils.addImage(this.scene, 140-350 , 15, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_LIGHT).setOrigin(0, 0);
        SpriteUtils.setDispSize(titleLight, 360 / 14 * 10 * CU.S, 65 * CU.S);
        titleLight.alpha = 0.8;

        const image = SpriteUtils.addImage(this.scene, 60-300, this.height / 2 - 4-10, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL, 0.8, 0.85).setOrigin(0.5, 0.5);
        const image2 = SpriteUtils.addImage(this.scene, 60-300, this.height / 2 - 4, Keys.ATLAS_BANK, "gems-1", 0.8).setOrigin(0.5, 0.5);

        let titleText = TextUtils.addTextAdvanced(scene, Tr('gn.gems').toUpperCase(), 125-300, 50,
            '#eec761', 20, 'normal', 450, 'left', 2, Fonts.BENGALY_NORMAL);
        titleText.setStroke('#000000', 1);

        let countText = TextUtils.addTextAdvanced(scene, Tr('gain.part.of.friend.emeralds'), 125-300, 75,
            '#8bb37d', 17, 'normal', 380, 'left', 1, Fonts.GOTHIC_DEUTSCH);
        countText.setOrigin(0, 0).setStroke('#000000', 1);
        let countIcon = SpriteUtils.addSprite(this.scene!, countText.getRightCenter().x! / CU.S + 1-300, 75 - 3, Keys.IMG_RES_GEM_NO_SHADOW)
            .setOrigin(0, 0);
        SpriteUtils.setDispSize(countIcon, 34 * CU.S, 34 * CU.S);
        countIcon.setVisible(false);

        let buyButton = SpriteUtils.scale(new SquareButton(this.scene, 530-300, this.height / 2 - 4, -10, Keys.UI_ART_GREEN_BUTTON,
            undefined, Keys.UI_GLASS, '', false, 84 * CU.S, 84 * CU.S, 0), 0.7 / CU.S);

        buyButton.setCallback(() => {
            detailsCallback();
        });

        let buyPriceText = TextUtils.addText(scene,
            Tr('details').toLowerCase(), 528-300, this.height / 2 + 28, '#ffffff', 13, 'bold', 200);

        const separator = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0.5);

        this.add([image, image2, buyButton, buyPriceText, titleLight,  titleText, countText, countIcon, separator]);
    }

}
